import React, { Component } from 'react';
import { translate } from '../../services';
import { HtmlComponent, SvgImage } from '..';
import { htmlParser } from '../../util';
import { PropTypes } from 'prop-types';
import { combineDispatchers, combineStates, mobilePageViewDispatcher, mobilePageViewState } from '../../store';
import { connect } from 'react-redux';
import { PathIndicatorNew } from '../../../style/images';
import $ from "jquery";

export class SearchCategoryComponent extends Component {
  pathToRoot( node ) {
    return node.parent && translate( node.parent.name ) !== translate( 'Categories' ) 
      ? [...this.pathToRoot( node.parent ), ' > ', translate( node.name )] 
      : [translate( node.name )];
  }
  
  getMarkedName() {
    const { node, searchString } = this.props; 
    const name = translate( node.name );  
    
    // if( !name.includesCaseInsensitive( searchString ) ) {
    //   return <span class  Name="name" title={ htmlParser.removeHtmlTags( name ) }>
    //     <HtmlComponent item={ name }/>
    //   </span>;
    // }
    
    // creates a escaped version of the search string, so that it can highlight all the matches
    // const matches = new RegExp( `(${searchString.split().join( '\\' )})`, 'ig' );
    // const htmlString = name.replace( matches, '<b>$1</b>' );

    const htmlString = `<b>${name}<b>`
    return <span className="name" title={ htmlParser.removeHtmlTags( htmlString ) } onClick={()=>{this.onClick()}}><HtmlComponent item={ htmlString }/></span>;
  }

  getPathTitle( path ) {
    return path.filter( pathPart => pathPart !== ' > ' ).map( pathPart => htmlParser.removeHtmlTags( pathPart ) ).join( ' > ' );
  }

  onClick = e => {
    this.props.showOther();
    const { node, onMouseDown } = this.props;
    e.stopPropagation();
    onMouseDown && onMouseDown( node );
  }

  calculateWordDimensions = function(text, classes, escape) {
    classes = classes || [];

    if (escape === undefined) {
        escape = true;
    }

    classes.push('textDimensionCalculation');

    var div = document.createElement('div');
    div.setAttribute('class', classes.join(' '));

    if (escape) {
        $(div).text(text);
    } else {
        div.innerHTML = text;
    }

    document.body.appendChild(div);

    var dimensions = {
        width : $(div).outerWidth(),
        height : $(div).outerHeight()
    };

    div.parentNode.removeChild(div);

    return dimensions;
  };

  calcPathComponents = path=>{
    let totalWidth = 0;
    let padding = 32;
    for(let i=0; i<path.length; i++){
      if(path[i]!==" > "){
        let dimension = this.calculateWordDimensions(path[i])
        totalWidth+=dimension.width;
      }
      else{
        totalWidth+=16
      }
    }
    let newPath = "";
    if(totalWidth>=window.innerWidth-32){
      newPath = ["..."," > ",path[path.length-1]];
      let newPathComponents = newPath.map( ( pathPart, key ) => {
        if(pathPart===" > "){
          return <div className='path-indicator'>
            {/* <HtmlComponent item={ pathPart } key={ key }/> */}
            <SvgImage source={ PathIndicatorNew }/>
          </div>
        }
        return <HtmlComponent className={"last-node"} item={ pathPart } key={ key }/>;
      });

      return newPathComponents;
    }
    else{
      let pathComponents = path.map( ( pathPart, key ) => {
        if(pathPart===" > "){
          return <div className='path-indicator'>
            {/* <HtmlComponent item={ pathPart } key={ key }/> */}
            <SvgImage source={ PathIndicatorNew }/>
          </div>
        }
        return <HtmlComponent item={ pathPart } key={ key }/> });
      return pathComponents;
    }
  }
  
  render() {
    const { node } = this.props;
    const path = this.pathToRoot( node );
    const pathComponents = path.map( ( pathPart, key ) => {
      if(pathPart===" > "){
        return <div className='path-indicator'>
          {/* <HtmlComponent item={ pathPart } key={ key }/> */}
          <SvgImage source={ PathIndicatorNew }/>
        </div>
      }
      return <HtmlComponent item={ pathPart } key={ key }/> });

    return<>
    {this.props.mobileView?<div className={this.props.className}>
      <div className='mobile-search-category' onMouseDown={this.onClick} onClick={this.onClick}>
        { this.getMarkedName() }
        <span className="path" title={ this.getPathTitle( path ) }>
          {this.calcPathComponents(path)}
          {/* { pathComponents } */}
        </span>
      </div>
    </div>:
      <div className={'row search-category' } onMouseDown={ this.onClick }>
      { this.getMarkedName() }
      <span className="path" title={ this.getPathTitle( path ) }>
        { pathComponents }
      </span>
    </div>}
    </> 
  }
}

SearchCategoryComponent.propTypes = {
  node: PropTypes.shape( {
    parent: PropTypes.object
  } ).isRequired, 
  onMouseDown: PropTypes.func.isRequired, 
  searchString: PropTypes.string.isRequired
};

export const SearchCategory = connect(combineStates(mobilePageViewState),combineDispatchers( mobilePageViewDispatcher))( SearchCategoryComponent ) ;